<template>

  <div class="step__group roomblock" role="group" :aria-labelledby="`cs2-group-label${index}`">
    <div class="step__minititle" :id="`cs2-group-label${index}`">{{ titleText }}</div>

    <TextInput :required="true" @setError="errors.name = $event" v-model="form.damagedata.rooms[index].name"
      text="Название помещения" :name="`damagedata-room${index}-name`" />
    <ShortFields class="pform__shortfields_3">
      <NumberInput :required="true" @setError="errors.size_length = $event"
        :name="`damagedata-room${index}-size-length`" v-model="form.damagedata.rooms[index].size.length"
        text="Длина (м)" :size-length="`damagedata-room${index}-size-length`" mask="-"
        tokens="{ '-': { 'pattern': '[0-9,.]', 'repeated': true } }" :validation="numberValidation" />
      <NumberInput :required="true" @setError="errors.size_width = $event" :name="`damagedata-room${index}-size-width`"
        v-model="form.damagedata.rooms[index].size.width" text="Ширина (м)"
        :size-width="`damagedata-room${index}-size-width`" mask="-"
        tokens="{ '-': { 'pattern': '[0-9,.]', 'repeated': true } }" :validation="numberValidation" />
      <NumberInput :required="true" @setError="errors.size_height = $event"
        :name="`damagedata-room${index}-size-height`" v-model="form.damagedata.rooms[index].size.height"
        text="Высота (м)" :size-height="`damagedata-room${index}-size-height`" mask="-"
        tokens="{ '-': { 'pattern': '[0-9,.]', 'repeated': true } }" :validation="numberValidation" />
    </ShortFields>

    <RadioGroup :required="true" title="Повреждена ли отделка потолка?" :values="['Да', 'Нет']"
      :name="`damagedata-room${index}-ceiling-damaged`" v-model="form.damagedata.rooms[index].ceiling.damaged"
      :class="{ 'mb0': dynamicfields.ceiling }" />
    <template v-if="dynamicfields.ceiling">
      <SelInput class="mb20" :required="true" text="Отделка потолка" :name="`damagedata-room${index}-ceiling-type`"
        :options="options.ceiling" v-model="form.damagedata.rooms[index].ceiling.type" />
      <p class="step__text">Приложите фото повреждений потолка</p>
      <FileInput :forbiddenFileExts="extra.forbiddenFileExts" @fileExtsChange="setFileExts(0, $event)"
        :name="`damagedata-room${index}-ceiling-files[]`" v-model="form.damagedata.rooms[index].ceiling.files" />
    </template>
    <RadioGroup :required="true" title="Повреждена ли отделка стен?" :values="['Да', 'Нет']"
      :name="`damagedata-room${index}-walls-damaged`" v-model="form.damagedata.rooms[index].walls.damaged"
      :class="{ 'mb20': dynamicfields.walls }" />
    <div class="step__group" role="group" :aria-labelledby="`cs2-group-subgroup${index}-label1`"
      v-if="dynamicfields.walls">
      <div class="step__minititle" :id="`cs2-group-subgroup${index}-label1`">Укажите тип(-ы) отделки стен:</div>
      <div class="step__group-cont step__group-cont-special">
        <CheckBox v-for="v, i in options.walls" :key="i" :name="`damagedata-room${index}-walls-type-${i}`"
          v-model="form.damagedata.rooms[index].walls.types[i]">
          {{ v }}</CheckBox>
      </div>
      <p class="step__text">Приложите фото повреждений стен</p>
      <FileInput :forbiddenFileExts="extra.forbiddenFileExts" @fileExtsChange="setFileExts(1, $event)"
        :name="`damagedata-room${index}-walls-files[]`" v-model="form.damagedata.rooms[index].walls.files" />
    </div>


    <RadioGroup :required="true" title="Повреждена ли отделка пола?" :values="['Да', 'Нет']"
      :name="`damagedata-room${index}-floor-damaged`" v-model="form.damagedata.rooms[index].floor.damaged"
      :class="{ 'mb0': dynamicfields.floor }" />
    <template v-if="dynamicfields.floor">
      <SelInput class="mb20" :required="true" text="Отделка пола" :name="`damagedata-room${index}-floor-type`"
        :options="options.floor" v-model="form.damagedata.rooms[index].floor.type" />
      <p class="step__text">Приложите фото повреждений пола</p>
      <FileInput :forbiddenFileExts="extra.forbiddenFileExts" @fileExtsChange="setFileExts(2, $event)"
        :name="`damagedata-room${index}-floor-files[]`" v-model="form.damagedata.rooms[index].floor.files" />
    </template>

    <RadioGroup :required="true" title="Повреждены ли двери?" :values="['Да', 'Нет']"
      :name="`damagedata-room${index}-doors-damaged`" v-model="form.damagedata.rooms[index].doors.damaged"
      :class="{ 'mb0': dynamicfields.doors }" />
    <template v-if="dynamicfields.doors">
      <SelInput class="mb20" :required="true" text="Материал дверей" :name="`damagedata-room${index}-doors-type`"
        :options="options.doors" v-model="form.damagedata.rooms[index].doors.type" />
      <p class="step__text">Приложите фото повреждений дверей</p>
      <FileInput :forbiddenFileExts="extra.forbiddenFileExts" @fileExtsChange="setFileExts(3, $event)"
        :name="`damagedata-room${index}-doors-files[]`" v-model="form.damagedata.rooms[index].doors.files" />
    </template>

    <RadioGroup :required="true" title="Повреждены ли окна?" :values="['Да', 'Нет']"
      :name="`damagedata-room${index}-windows-damaged`" v-model="form.damagedata.rooms[index].windows.damaged"
      :class="{ 'mb0': dynamicfields.windows }" />
    <template v-if="dynamicfields.windows">
      <SelInput class="mb20" :required="true" text="Материал окон" :name="`damagedata-room${index}-windows-type`"
        :options="options.windows" v-model="form.damagedata.rooms[index].windows.type" />
      <p class="step__text">Приложите фото повреждений окон</p>
      <FileInput :forbiddenFileExts="extra.forbiddenFileExts" @fileExtsChange="setFileExts(4, $event)"
        :name="`damagedata-room${index}-windows-files[]`" v-model="form.damagedata.rooms[index].windows.files" />
    </template>


  </div>

</template>

<script>
import { mapState } from 'vuex';
import CheckBox from '@/components/inputs/CheckBox.vue';
import NumberInput from '@/components/inputs/NumberInput.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import ShortFields from '@/components/ShortFields.vue';
import SelInput from '@/components/inputs/SelInput.vue';
import FileInput from '@/components/inputs/FileInput.vue';
import { numberValidation } from '@/helpers/validations';
import { roomTemplate } from '@/helpers/data';

export default {
  components: { CheckBox, NumberInput, RadioGroup, ShortFields, TextInput, SelInput, FileInput },
  data: () => ({
    errors: {},
    numberValidation,
    refreshKey: 0,
    options: {
      ceiling: ['', 'Окраска', 'Обои', 'Натяжной', 'Реечный', 'Гипсокартон', 'Плитка ПВХ', 'Другое'],
      walls: {
        oboi_bumazhnie: 'Обои (бумажные)',
        oboi_vinilovie: 'Обои (виниловые, флизелиновые)',
        oboi_pod_pokrasku: 'Обои под покраску',
        oboi_tkanevye: 'Обои (тканевые)',
        okraska: 'Окраска',
        venicianskaya_shtukaturka: 'Венецианская штукатурка',
        derevyannie_paneli: 'Деревянные панели',
        gipsokarton: 'Гипсокартон',
        plitka: 'Плитка',
        plastikovie_paneli: 'Пластиковые панели',
        drugoe: 'Другое',
      },
      floor: ['', 'Ламинат', 'Паркетная доска', 'Паркет', 'Массив', 'Линолеум', 'Плитка/камень', 'Наливной', 'Пробка', 'Другое'],
      doors: ['', 'Дерево', 'МДФ', 'Экошпон', 'ПВХ', 'Стекло', 'Другое'],
      windows: ['', 'Дерево', 'Пластик', 'Алюминий']
    }
  }),
  beforeMount() {
    if (!this.form.damagedata.rooms[this.index])
      this.form.damagedata.rooms[this.index] = roomTemplate()
  },
  unmounted() {
    delete this.form.damagedata.rooms[this.index]
  },
  props: {
    index: { type: Number, required: true },
    modelValue: { type: Boolean, default: false }
  },
  methods: {
    setFileExts(index, array) {
      this.extra.fileExts['room' + this.index + '_' + index] = array
      this.refreshKey++
    },
  },
  computed: {
    ...mapState(['form', 'extra']),
    titleText() {
      switch (this.index) {
        case 1: return 'Первое помещение'
        case 2: return 'Второе помещение'
        case 3: return 'Третье помещение'
        case 4: return 'Четвёртое помещение'
        case 5: return 'Пятое помещение'
        default: return 'Помещение #' + this.index
      }
    },
    dynamicfields() {
      let obj = {}
      for (let key of ['ceiling', 'walls', 'floor', 'doors', 'windows']) {
        obj[key] = this.form.damagedata.rooms[this.index]?.[key].damaged.toLowerCase().trim() == 'да' ? true : false
      }
      return obj
    },
    filled() {
      this.refreshKey;

      for (let key in this.errors)
        if (this.errors[key]) return false

      let req = ['name', 'size.length', 'size.width', 'size.height',
        'ceiling.damaged', 'walls.damaged', 'floor.damaged', 'doors.damaged', 'windows.damaged',
      ]

      for (let complexkey of req) {
        let [key, subkey] = complexkey.split('.')
        if (subkey) {
          if (!this.form.damagedata.rooms[this.index]?.[key][subkey])
            return false
        } else {
          if (!this.form.damagedata.rooms[this.index]?.[key])
            return false
        }
      }

      let dyn = ['ceiling', 'floor', 'doors', 'windows']

      for (let d of dyn)
        if (this.dynamicfields[d]) {
          if (!this.form.damagedata.rooms[this.index]?.[d].type)
            return false
          //if (!this.form.damagedata.rooms[this.index]?.[d].files?.length)
          //  return false
        }

      if (this.dynamicfields.walls) {
        //if (!this.form.damagedata.rooms[this.index]?.walls.files?.length)
        //  return false
        for (let key in this.options.walls) {
          if (this.form.damagedata.rooms[this.index]?.walls.types[key])
            return true
        }
        return false
      }
      return true
    },
  },
  watch: {
    filled: {
      handler(v) {
        this.$emit('update:modelValue', v)
      },
      immediate: true
    }
  }
}
</script>

<style lang="sass" scoped>
.step__group-cont-special >*:last-child
  margin-bottom: 20px
.roomblock
  margin-bottom: 60px
</style>